/**
 * EVRLIGHT — Premium Visual Animations
 * Runs as a standard script (non-module) so it loads without import map.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  /* ═══════════════════════════════════════════════════════════
     1. SCROLL FADE-IN / SLIDE-UP
     Marks product cards, collection cards, and section blocks
     with [data-animate], then reveals them via IntersectionObserver.
     Grid parents get [data-animate-stagger] for cascading delays.
  ═══════════════════════════════════════════════════════════ */

  function initScrollFade() {
    if (reducedMotion) return;

    /* ── Elemente die EINZELN animieren ── */
    var ITEM_SELECTORS = [
      /* Karten / Grid-Kinder */
      '.product-grid__card',
      '.collection-card',
      '.resource-card',
      '.featured-collection-block',
      '.blog-post-card',
      '.blog-post-item',
      '.collection-links__item',
      /* Listen-Zeilen */
      '.resource-list__item',
      /* Sektions-Text-Blöcke */
      '.shopify-section .section__header',
      '.shopify-section .hero__content',
      '.shopify-section .media-with-content__content',
      '.shopify-section .marquee',
      /* Produktseite */
      '.product-information__media',
      '.product-information__details',
      /* Featured product */
      '.featured-product .section-content-wrapper',
      /* Image / Media Blocks */
      '.image-block',
      '.media-block',
      /* Vers des Tages */
      '.verse-of-day__inner',
      /* Footer */
      '.footer-utilities__group-copyright',
      '.footer-nav-block',
    ].join(',');

    /* ── Eltern-Container die Stagger auslösen ── */
    var STAGGER_SELECTORS = [
      '.product-grid',
      '.collection-list__grid',
      '.featured-blog-posts__grid',
      '.collection-links__container',
      '.blog-posts-container',
      '.product-recommendations .section-resource-list__content',
    ].join(',');

    /* ── Elemente die als ganzes (nicht als Kind) staggern ── */
    var STAGGER_CHILD_SELECTORS = [
      /* Footer-Spalten nebeneinander */
      '.footer-section__column',
      /* Kollektion-Kacheln in collection-list */
      '.collection-list__grid > *',
    ].join(',');

    function mark(scope) {
      scope = scope || document;

      /* Stagger-Wrapper markieren */
      scope.querySelectorAll(STAGGER_SELECTORS).forEach(function (el) {
        if (!el.hasAttribute('data-animate-stagger')) {
          el.setAttribute('data-animate-stagger', '');
        }
      });

      /* Alle Einzel-Elemente */
      scope.querySelectorAll(ITEM_SELECTORS).forEach(function (el) {
        /* Nicht doppelt markieren, nicht bereits sichtbare */
        if (!el.hasAttribute('data-animate') && !el.classList.contains('is-visible')) {
          el.setAttribute('data-animate', '');
        }
      });

      /* Stagger-Kinder, die noch kein data-animate vom Eltern-Stagger haben */
      scope.querySelectorAll(STAGGER_CHILD_SELECTORS).forEach(function (el) {
        if (!el.hasAttribute('data-animate') && !el.classList.contains('is-visible')) {
          el.setAttribute('data-animate', '');
          /* Elternteil als Stagger-Container markieren, falls noch nicht */
          if (el.parentElement && !el.parentElement.hasAttribute('data-animate-stagger')) {
            el.parentElement.setAttribute('data-animate-stagger', '');
          }
        }
      });

      /* ── Direktionale Richtungsattribute setzen ── */
      /* Sektions-Header: von links */
      scope.querySelectorAll('.section__header, .media-with-content__content').forEach(function (el) {
        if (!el.getAttribute('data-animate-dir')) {
          el.setAttribute('data-animate-dir', 'left');
        }
      });

      /* Bilder / Medien: von rechts */
      scope.querySelectorAll('.media-with-content__media, .image-block, .media-block').forEach(function (el) {
        if (!el.getAttribute('data-animate-dir')) {
          el.setAttribute('data-animate-dir', 'right');
        }
      });

      /* Produktkarten: Spring-Scale */
      scope.querySelectorAll('.product-grid__card').forEach(function (el) {
        if (!el.getAttribute('data-animate-dir')) {
          el.setAttribute('data-animate-dir', 'product');
        }
      });
    }

    function createObserver() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-animate]').forEach(function (el) {
          el.classList.add('is-visible');
        });
        return null;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var el = entry.target;
              /* will-change kurz vor Reveal setzen → nur das animierende Element promoted */
              el.style.willChange = 'opacity, transform';
              el.classList.add('is-visible');
              observer.unobserve(el);
              /* will-change nach Transition-Ende freigeben */
              el.addEventListener('transitionend', function cleanup() {
                el.style.willChange = 'auto';
                el.removeEventListener('transitionend', cleanup);
              }, { once: true });
            }
          });
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0.04 }
      );

      function observeAll() {
        document.querySelectorAll('[data-animate]:not(.is-visible)').forEach(function (el) {
          observer.observe(el);
        });
      }

      observeAll();
      return { observer: observer, observeAll: observeAll };
    }

    mark();
    var obs = createObserver();

    /* Re-scan nach Shopify-Sektions-Updates (Filter, Quick Add, etc.) */
    document.addEventListener('shopify:section:load', function (e) {
      mark(e.target);
      if (obs) { obs.observeAll(); }
    });

    /* Re-scan nach AJAX-Navigation (Kollektion-Filter etc.) */
    document.addEventListener('page:load', function () {
      mark();
      if (obs) { obs.observeAll(); }
    });
  }


  /* ═══════════════════════════════════════════════════════════
     2. MAGNETIC BUTTONS
     Only active on devices with a fine pointer (mouse).
     Buttons move max 9px toward the cursor, spring back on leave.
     Uses lerp + rAF for smooth motion.
  ═══════════════════════════════════════════════════════════ */

  function initMagneticButtons() {
    // Require fine pointer (mouse) AND no reduced-motion preference
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (reducedMotion) return;

    var SELECTOR = [
      '.button:not(.button-unstyled)',
      '.button-secondary',
      '[data-magnetic]',
    ].join(',');

    var MAX_MOVE = 9; // px
    var LERP_FACTOR = 0.13;
    var SNAP_THRESHOLD = 0.08; // px — stop rAF below this

    function attachMagnet(btn) {
      var targetX = 0, targetY = 0;
      var currentX = 0, currentY = 0;
      var rafId = null;
      var isHovered = false;

      function lerp(a, b, t) { return a + (b - a) * t; }

      function tick() {
        currentX = lerp(currentX, targetX, LERP_FACTOR);
        currentY = lerp(currentY, targetY, LERP_FACTOR);

        btn.style.transform = 'translate(' + currentX.toFixed(2) + 'px, ' + currentY.toFixed(2) + 'px)';

        var stillMoving =
          Math.abs(targetX - currentX) > SNAP_THRESHOLD ||
          Math.abs(targetY - currentY) > SNAP_THRESHOLD;

        if (stillMoving) {
          rafId = requestAnimationFrame(tick);
        } else {
          // Snap cleanly to 0 when resting at origin after leave
          if (!isHovered) {
            btn.style.transform = '';
            currentX = 0;
            currentY = 0;
          }
          rafId = null;
        }
      }

      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var cx = rect.left + rect.width * 0.5;
        var cy = rect.top + rect.height * 0.5;
        var dx = (e.clientX - cx) / (rect.width * 0.5);
        var dy = (e.clientY - cy) / (rect.height * 0.5);

        // Clamp to [-1, 1] so corners don't over-extend
        dx = Math.max(-1, Math.min(1, dx));
        dy = Math.max(-1, Math.min(1, dy));

        targetX = dx * MAX_MOVE;
        targetY = dy * MAX_MOVE;

        if (!rafId) rafId = requestAnimationFrame(tick);
      });

      btn.addEventListener('mouseenter', function () {
        isHovered = true;
      });

      btn.addEventListener('mouseleave', function () {
        isHovered = false;
        targetX = 0;
        targetY = 0;
        if (!rafId) rafId = requestAnimationFrame(tick);
      });
    }

    function setup() {
      document.querySelectorAll(SELECTOR).forEach(function (btn) {
        // Avoid attaching twice
        if (btn.dataset.magneticAttached) return;
        btn.dataset.magneticAttached = '1';
        attachMagnet(btn);
      });
    }

    document.addEventListener('DOMContentLoaded', setup);
    document.addEventListener('shopify:section:load', setup);
  }


  /* ═══════════════════════════════════════════════════════════
     3. TEXT REVEAL ANIMATION
     Targets elements with [data-text-reveal].
     Splits text into words, each wrapped in a span with a staggered
     CSS custom property delay, then revealed via IntersectionObserver.
  ═══════════════════════════════════════════════════════════ */

  function initTextReveal() {
    // Auto-mark large headings in hero/slideshow areas, plus any manual [data-text-reveal]
    var AUTO_SELECTORS = [
      '.hero__content-wrapper h1',
      '.hero__content-wrapper h2',
      '.slideshow__slide h1',
      '.slideshow__slide h2',
      '.jumbo-text',
      '.media-with-content__content h1',
      '.media-with-content__content h2',
    ].join(',');

    document.querySelectorAll(AUTO_SELECTORS).forEach(function (el) {
      if (!el.hasAttribute('data-text-reveal')) {
        el.setAttribute('data-text-reveal', '');
      }
    });

    var SELECTOR = '[data-text-reveal]';
    var isMobile = window.innerWidth < 750;

    // Base delay per word: slightly faster on mobile
    var WORD_DELAY_DESKTOP = 0.07; // seconds
    var WORD_DELAY_MOBILE = 0.05;

    function splitWords(el) {
      // Guard: already split
      if (el.querySelector('.text-reveal-word')) return;

      var baseDelay = isMobile ? WORD_DELAY_MOBILE : WORD_DELAY_DESKTOP;
      var words = el.textContent.trim().split(/\s+/);

      el.innerHTML = words.map(function (word, i) {
        var delay = (i * baseDelay).toFixed(2);
        return '<span class="text-reveal-word" style="--word-delay:' + delay + 's">' + word + '</span>';
      }).join(' ');
    }

    function revealEl(el) {
      el.querySelectorAll('.text-reveal-word').forEach(function (span) {
        span.classList.add('is-visible');
      });
    }

    function observe() {
      var els = document.querySelectorAll(SELECTOR);
      if (!els.length) return;

      // If reduced motion: skip splitting, CSS shows words immediately
      if (reducedMotion) {
        els.forEach(function (el) { el.style.visibility = 'visible'; });
        return;
      }

      els.forEach(splitWords);

      if (!('IntersectionObserver' in window)) {
        els.forEach(revealEl);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealEl(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0.1 }
      );

      els.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }
  }


  /* ═══════════════════════════════════════════════════════════
     4. VERSE OF THE DAY
     Picks a verse by day-of-year (same verse for all visitors
     on the same calendar day). Fades in with glow on scroll-into-view.
  ═══════════════════════════════════════════════════════════ */

  function initVerseOfDay() {
    var container = document.getElementById('verse-of-day');
    if (!container) return;

    /* Verse-Liste — Quelle: assets/evrlight-verses.json (Lutherbibel 2017) */
    var VERSES = [
      { text: 'Ich vermag alles durch den, der mich stärkt.', ref: 'Phil 4,13' },
      { text: 'Der HERR ist mein Licht und mein Heil; vor wem sollte ich mich fürchten?', ref: 'Ps 27,1' },
      { text: 'Habt Mut, ich habe die Welt überwunden.', ref: 'Joh 16,33' },
      { text: 'Ihr seid das Licht der Welt.', ref: 'Mt 5,14' },
      { text: 'Der HERR wird kämpfen für euch, und ihr werdet stille sein.', ref: 'Ex 14,14' },
      { text: 'Glaube an den Herrn Jesus, so wirst du und dein Haus selig.', ref: 'Apg 16,31' },
      { text: 'Er gibt dem Müden Kraft und Stärke genug dem Unvermögenden.', ref: 'Jes 40,29' },
      { text: 'Denn ich weiß, was ich für Gedanken über euch habe: Gedanken des Friedens und nicht des Leids.', ref: 'Jer 29,11' },
      { text: 'Die auf den HERRN harren, kriegen neue Kraft.', ref: 'Jes 40,31' },
      { text: 'Alle eure Sorge werfet auf ihn; denn er sorgt für euch.', ref: '1 Petr 5,7' },
      { text: 'Fürchte dich nicht, denn ich bin mit dir; weiche nicht, denn ich bin dein Gott.', ref: 'Jes 41,10' },
      { text: 'Gott ist unsere Zuflucht und Stärke, eine Hilfe in den großen Nöten.', ref: 'Ps 46,2' },
      { text: 'Sei stark und mutig; sei nicht erschrocken und entsetze dich nicht.', ref: 'Jos 1,9' },
      { text: 'Frieden lasse ich euch, meinen Frieden gebe ich euch.', ref: 'Joh 14,27' },
      { text: 'Der HERR behüte deinen Ausgang und Eingang von nun an bis in Ewigkeit.', ref: 'Ps 121,8' },
      { text: 'Ich bin das Licht der Welt. Wer mir nachfolgt, wird nicht in der Finsternis wandeln.', ref: 'Joh 8,12' },
      { text: 'Trachtet zuerst nach dem Reich Gottes und nach seiner Gerechtigkeit, so wird euch das alles zufallen.', ref: 'Mt 6,33' },
      { text: 'Seid ihr stark und lasst eure Hände nicht sinken; denn euer Werk wird belohnt werden.', ref: '2 Chr 15,7' },
      { text: 'Wir wandeln im Glauben und nicht im Schauen.', ref: '2 Kor 5,7' },
      { text: 'Der HERR ist mein Hirte, mir wird nichts mangeln.', ref: 'Ps 23,1' },
      { text: 'Denn aus Gnade seid ihr selig geworden durch Glauben.', ref: 'Eph 2,8' },
      { text: 'Fürchte dich nicht, denn ich habe dich erlöst; ich habe dich bei deinem Namen gerufen; du bist mein.', ref: 'Jes 43,1' },
      { text: 'Die Liebe höret nimmer auf.', ref: '1 Kor 13,8' },
      { text: 'Ich bin die Auferstehung und das Leben.', ref: 'Joh 11,25' },
      { text: 'Mir ist gegeben alle Gewalt im Himmel und auf Erden.', ref: 'Mt 28,18' },
      { text: 'Dem aber, der über alle Maßen mehr tun kann, als wir bitten oder verstehen, sei Ehre.', ref: 'Eph 3,20' },
      { text: 'Erkennet, dass der HERR Gott ist; er hat uns gemacht und nicht wir selbst.', ref: 'Ps 100,3' },
      { text: 'Wer den HERRN fürchtet, hat eine starke Zuversicht.', ref: 'Spr 14,26' },
      { text: 'Gott ist Licht, und in ihm ist keine Finsternis.', ref: '1 Joh 1,5' },
      { text: 'Ja, ich komme bald. Amen. Ja, komm, Herr Jesu!', ref: 'Offb 22,20' },
      { text: 'Wir wissen aber, dass denen, die Gott lieben, alle Dinge zum Besten dienen.', ref: 'Röm 8,28' },
      { text: 'Es ist aber der Glaube eine feste Zuversicht auf das, was man hofft, und ein Nichtzweifeln an dem, was man nicht sieht.', ref: 'Hebr 11,1' },
      { text: 'Der Gott der Hoffnung aber erfülle euch mit aller Freude und Frieden im Glauben.', ref: 'Röm 15,13' },
      { text: 'Denn Gott hat uns nicht gegeben den Geist der Furcht, sondern der Kraft und der Liebe und der Besonnenheit.', ref: '2 Tim 1,7' },
      { text: 'Vertraue dem HERRN von ganzem Herzen und verlass dich nicht auf deinen Verstand.', ref: 'Spr 3,5' },
      { text: 'Befiehl dem HERRN deinen Weg und hoffe auf ihn, er wird\'s vollbringen.', ref: 'Ps 37,5' },
      { text: 'Alle Dinge sind möglich dem, der glaubt.', ref: 'Mk 9,23' },
      { text: 'Ich lebe, doch nun nicht ich, sondern Christus lebt in mir.', ref: 'Gal 2,20' },
      { text: 'Wir lieben, denn er hat uns zuerst geliebt.', ref: '1 Joh 4,19' },
      { text: 'Denn also hat Gott die Welt geliebt, dass er seinen eingeborenen Sohn gab.', ref: 'Joh 3,16' },
      { text: 'Nun aber bleiben Glaube, Hoffnung, Liebe, diese drei; aber die größte unter ihnen ist die Liebe.', ref: '1 Kor 13,13' },
      { text: 'Denn ich bin gewiss, dass weder Tod noch Leben uns scheiden kann von der Liebe Gottes in Christus Jesus.', ref: 'Röm 8,38–39' },
      { text: 'Ich habe dich lieb, HERR, meine Stärke!', ref: 'Ps 18,2' },
      { text: 'Seid stark in dem Herrn und in der Macht seiner Stärke.', ref: 'Eph 6,10' },
      { text: 'Und das Licht scheint in der Finsternis, und die Finsternis hat es nicht ergriffen.', ref: 'Joh 1,5' },
      { text: 'Vertraut auf den HERRN immerdar; denn der HERR ist ein Fels ewiglich.', ref: 'Jes 26,4' },
      { text: 'Meine Gnade genügt dir; denn meine Kraft ist in den Schwachen mächtig.', ref: '2 Kor 12,9' },
      { text: 'Der HERR ist meine Stärke und mein Schild; auf ihn traut mein Herz.', ref: 'Ps 28,7' },
      { text: 'Niemand hat größere Liebe als die, dass er sein Leben lässt für seine Freunde.', ref: 'Joh 15,13' },
      { text: 'Ich schäme mich des Evangeliums nicht; denn es ist eine Kraft Gottes.', ref: 'Röm 1,16' },
      { text: 'Schmecket und sehet, wie freundlich der HERR ist.', ref: 'Ps 34,9' },
      { text: 'Kommt her zu mir, alle, die ihr mühselig und beladen seid; ich will euch erquicken.', ref: 'Mt 11,28' },
      { text: 'Die auf dich hoffen, verlässt du nicht, HERR.', ref: 'Ps 9,11' },
      { text: 'Gott aber erweist seine Liebe zu uns darin, dass Christus für uns gestorben ist.', ref: 'Röm 5,8' },
      { text: 'Was ihr tut, das tut von Herzen als dem Herrn und nicht den Menschen.', ref: 'Kol 3,23' },
      { text: 'Gott ist treu, der euch nicht versuchen lässt über eure Kraft.', ref: '1 Kor 10,13' },
      { text: 'Wenn mir gleich Leib und Seele verschmachtet, so bist du doch, Gott, allezeit meines Herzens Trost.', ref: 'Ps 73,26' },
      { text: 'Jesus Christus gestern und heute und derselbe auch in Ewigkeit.', ref: 'Hebr 13,8' },
      { text: 'Denn Berge werden weichen und Hügel hinfallen, aber meine Gnade wird nicht von dir weichen.', ref: 'Jes 54,10' },
      { text: 'Dein Wort ist meines Fußes Leuchte und ein Licht auf meinem Weg.', ref: 'Ps 119,105' },
      { text: 'Ich bin gekommen, damit sie das Leben und volle Genüge haben sollen.', ref: 'Joh 10,10' },
      { text: 'Seid fröhlich in Hoffnung, geduldig in Trübsal, beharrlich im Gebet.', ref: 'Röm 12,12' },
      { text: 'Der HERR ist meine Stärke und mein Lobgesang und ist mein Heil.', ref: 'Ex 15,2' },
      { text: 'Meine Seele ist stille zu Gott, der mir hilft.', ref: 'Ps 62,2' },
      { text: 'So lasst euer Licht leuchten vor den Leuten.', ref: 'Mt 5,16' },
      { text: 'Der in euch ist, ist größer als der in der Welt.', ref: '1 Joh 4,4' },
      { text: 'Der Name des HERRN ist ein starker Turm; der Gerechte läuft dazu und wird beschützt.', ref: 'Spr 18,10' },
      { text: 'Seid stark, und euer Herz sei unverzagt, alle, die ihr auf den HERRN hofft.', ref: 'Ps 31,25' },
      { text: 'Siehe, Gott ist mein Heil; ich vertraue und fürchte mich nicht.', ref: 'Jes 12,2' },
      { text: 'Und der Friede Gottes, der allen Verstand übersteigt, wird eure Herzen und Sinne bewahren.', ref: 'Phil 4,7' },
      { text: 'Er heilt, die zerbrochenen Herzens sind, und verbindet ihre Wunden.', ref: 'Ps 147,3' },
      { text: 'In dem allen überwinden wir weit durch den, der uns geliebt hat.', ref: 'Röm 8,37' },
      { text: 'Mach dich auf, werde licht; denn dein Licht kommt, und die Herrlichkeit des HERRN geht auf über dir.', ref: 'Jes 60,1' },
      { text: 'Ich bin der Weinstock, ihr seid die Reben; wer in mir bleibt und ich in ihm, der bringt viel Frucht.', ref: 'Joh 15,5' },
      { text: 'Die Güte des HERRN hat kein Ende, seine Barmherzigkeit hört nicht auf. Sie ist jeden Morgen neu.', ref: 'Klgl 3,22–23' },
      { text: 'Wirf dein Anliegen auf den HERRN; er wird dich versorgen.', ref: 'Ps 55,23' },
      { text: 'Bei Menschen ist das unmöglich; aber bei Gott sind alle Dinge möglich.', ref: 'Mt 19,26' },
      { text: 'Zur Freiheit hat uns Christus befreit.', ref: 'Gal 5,1' },
      { text: 'Ich habe den HERRN stets vor Augen; er ist mir zur Rechten, ich werde nicht wanken.', ref: 'Ps 16,8' },
      { text: 'So gibt es nun keine Verdammnis für die, die in Christus Jesus sind.', ref: 'Röm 8,1' },
      { text: 'Denn der HERR Gott ist Sonne und Schild; Gnade und Ehre gibt der HERR.', ref: 'Ps 84,12' },
      { text: 'Wenn du durchs Wasser gehst, will ich bei dir sein; und wenn du durch Feuer gehst, sollst du nicht brennen.', ref: 'Jes 43,2' },
      { text: 'Christus in euch, die Hoffnung der Herrlichkeit.', ref: 'Kol 1,27' },
      { text: 'Ich bin der Weg und die Wahrheit und das Leben.', ref: 'Joh 14,6' },
      { text: 'Das Volk, das im Finstern wandelt, sieht ein großes Licht.', ref: 'Jes 9,1' },
      { text: 'Harre des HERRN! Sei stark und dein Herz fasse Mut; ja, harre des HERRN!', ref: 'Ps 27,14' },
      { text: 'Die Freude am HERRN ist eure Stärke.', ref: 'Neh 8,10' },
      { text: 'Dein Wort ist die Wahrheit.', ref: 'Joh 17,17' },
      { text: 'Der HERR ist nahe allen, die ihn anrufen, allen, die ihn ernsthaft anrufen.', ref: 'Ps 145,18' },
      { text: 'Der Weg der Gerechten aber ist wie das Licht des Morgens.', ref: 'Spr 4,18' },
      { text: 'Selig ist der Mann, der die Anfechtung erduldet.', ref: 'Jak 1,12' },
      { text: 'Fraget nach dem HERRN und seiner Macht; suchet sein Angesicht allezeit!', ref: '1 Chr 16,11' },
      { text: 'Ich bin darin guter Zuversicht, dass der, der in euch das gute Werk begonnen hat, es vollenden wird.', ref: 'Phil 1,6' },
      { text: 'Trachtet nach dem, was droben ist, nicht nach dem, was auf Erden ist.', ref: 'Kol 3,2' },
      { text: 'Zur Zeit meiner Not rufe ich zu dir; denn du erhörst mich.', ref: 'Ps 86,7' },
      { text: 'Denket nicht an das Frühere! Siehe, ich will etwas Neues schaffen.', ref: 'Jes 43,18–19' },
      { text: 'Wer unter dem Schirm des Höchsten sitzt und unter dem Schatten des Allmächtigen bleibt.', ref: 'Ps 91,1' },
      { text: 'Ich will euch ein neues Herz und einen neuen Geist in euch geben.', ref: 'Hes 36,26' },
      { text: 'Lasst uns aber Gutes tun und nicht müde werden; denn zu seiner Zeit werden wir auch ernten.', ref: 'Gal 6,9' },
      { text: 'Du aber, HERR, bist ein Schild um mich, du bist meine Ehre und der mein Haupt emporhebt.', ref: 'Ps 3,4' },
      { text: 'Bittet, so wird euch gegeben; suchet, so werdet ihr finden; klopfet an, so wird euch aufgetan.', ref: 'Mt 7,7' },
      { text: 'Ich danke dir dafür, dass ich wunderbar gemacht bin.', ref: 'Ps 139,14' },
      { text: 'Seht, welch eine Liebe hat uns der Vater gegeben, dass wir Kinder Gottes heißen sollen.', ref: '1 Joh 3,1' },
      { text: 'Durch seine Wunden sind wir geheilt.', ref: 'Jes 53,5' },
      { text: 'Wie der Hirsch lechzt nach frischem Wasser, so lechzt meine Seele, Gott, nach dir.', ref: 'Ps 42,2' },
      { text: 'Ich habe vor dir eine offene Tür gegeben, und niemand kann sie schließen.', ref: 'Offb 3,8' },
      { text: 'Des Menschen Herz plant seinen Weg; aber der HERR lenkt seinen Schritt.', ref: 'Spr 16,9' },
      { text: 'Seid stille und erkennet, dass ich Gott bin.', ref: 'Ps 46,11' },
      { text: 'Und stellt euch nicht dieser Welt gleich, sondern wandelt euch durch Erneuerung eures Sinnes.', ref: 'Röm 12,2' },
      { text: 'Und ihr werdet die Wahrheit erkennen, und die Wahrheit wird euch frei machen.', ref: 'Joh 8,32' },
      { text: 'Kämpfe den guten Kampf des Glaubens.', ref: '1 Tim 6,12' },
      { text: 'Denn ich, der HERR, dein Gott, halte deine rechte Hand.', ref: 'Jes 41,13' },
      { text: 'Sorgt euch um nichts, sondern in allen Dingen lasst eure Bitten in Gebet und Flehen mit Danksagung vor Gott kundwerden.', ref: 'Phil 4,6' },
      { text: 'Denn du bist meine Hoffnung, HERR, mein Vertrauen von Jugend auf.', ref: 'Ps 71,5' },
      { text: 'Tröstet, tröstet mein Volk, spricht euer Gott.', ref: 'Jes 40,1' },
      { text: 'Und Gott wird abwischen alle Tränen von ihren Augen, und der Tod wird nicht mehr sein.', ref: 'Offb 21,4' },
      { text: 'Wenn ich mich fürchte, so hoffe ich auf dich.', ref: 'Ps 56,4' },
      { text: 'Wie ihr nun Christus Jesus, den Herrn, angenommen habt, so lebt auch in ihm.', ref: 'Kol 2,6' },
      { text: 'Du wirst mich auf dem Weg des Lebens leiten; vor deinem Angesicht ist Freude die Fülle.', ref: 'Ps 16,11' },
      { text: 'Der HERR lenkt des Menschen Herz wie Wasserbäche, wohin er will.', ref: 'Spr 21,1' },
      { text: 'Gelobt sei Gott, der Vater der Barmherzigkeit und Gott alles Trostes.', ref: '2 Kor 1,3' },
      { text: 'Du stellst meine Füße auf weiten Raum.', ref: 'Ps 31,9' },
      { text: 'Gott ist die Liebe; und wer in der Liebe bleibt, der bleibt in Gott und Gott in ihm.', ref: '1 Joh 4,16' },
      { text: 'Ohne Glauben aber ist es unmöglich, Gott zu gefallen.', ref: 'Hebr 11,6' },
      { text: 'Lasst uns festhalten an dem Bekenntnis der Hoffnung und nicht wanken.', ref: 'Hebr 10,23' },
      { text: 'Ihr seid ein auserwähltes Geschlecht, eine königliche Priesterschaft, ein heiliges Volk.', ref: '1 Petr 2,9' },
      { text: 'Der HERR ist groß und sehr zu loben, und seine Größe ist unerforschlich.', ref: 'Ps 145,3' },
      { text: 'Denn wir haben nicht einen Hohenpriester, der nicht könnte mitleiden mit unserer Schwachheit.', ref: 'Hebr 4,15' },
      { text: 'Ich weiß, an wen ich glaube.', ref: '2 Tim 1,12' },
      { text: 'Lobet den HERRN, alle Heiden; preiset ihn, alle Völker!', ref: 'Ps 117,1' },
    ];

    // Day-of-year index — same for every visitor on the same date
    var now = new Date();
    var startOfYear = new Date(now.getFullYear(), 0, 0);
    var dayOfYear = Math.floor((now - startOfYear) / 86400000);
    var verse = VERSES[dayOfYear % VERSES.length];

    var textEl = container.querySelector('.verse-of-day__text');
    var refEl = container.querySelector('.verse-of-day__reference');
    var glowEl = container.querySelector('.verse-of-day__glow');

    if (!textEl || !refEl) return;

    textEl.textContent = '„' + verse.text + '“'; // „..."
    refEl.textContent = verse.ref;

    function reveal() {
      // Stagger: glow first, then text, then reference
      if (glowEl) glowEl.classList.add('is-shown');
      setTimeout(function () { textEl.classList.add('is-shown'); }, 120);
      setTimeout(function () { refEl.classList.add('is-shown'); }, 420);
    }

    // If reduced motion: show immediately without transitions (CSS handles it)
    if (reducedMotion) {
      reveal();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          reveal();
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(container);
  }


  /* ═══════════════════════════════════════════════════════════
     5. CUSTOM CURSOR (Desktop / pointer: fine only)
     - Outer ring follows with lerp (lag) for premium feel
     - Inner dot tracks exactly
     - Enlarges on hover over interactive elements
  ═══════════════════════════════════════════════════════════ */

  function initCustomCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (reducedMotion) return;

    var ring = document.createElement('div');
    ring.className = 'ev-cursor is-hidden';
    ring.innerHTML = '<div class="ev-cursor__ring"></div>';
    var dot = document.createElement('div');
    dot.className = 'ev-cursor__dot is-hidden';
    document.body.appendChild(ring);
    document.body.appendChild(dot);

    var LERP = 0.38;
    var STOP_THRESHOLD = 0.15; /* px — rAF stoppt wenn Ring nah genug am Ziel */
    var mx = -100, my = -100;
    var rx = -100, ry = -100;
    var visible = false;
    var rafId = null;

    var INTERACTIVE = 'a, button, [role="button"], input, select, textarea, label, summary, [data-magnetic], .product-grid__card, .collection-card';

    function tick() {
      rx += (mx - rx) * LERP;
      ry += (my - ry) * LERP;
      ring.style.transform = 'translate(' + (rx - 14).toFixed(1) + 'px, ' + (ry - 14).toFixed(1) + 'px)';

      /* Stoppe rAF sobald Ring am Ziel ist — kein permanenter Loop */
      if (Math.abs(mx - rx) < STOP_THRESHOLD && Math.abs(my - ry) < STOP_THRESHOLD) {
        rafId = null;
        return;
      }
      rafId = requestAnimationFrame(tick);
    }

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      /* Dot folgt sofort — kein Lag */
      dot.style.transform = 'translate(' + (mx - 2.5) + 'px, ' + (my - 2.5) + 'px)';
      /* rAF nur starten wenn nicht schon läuft */
      if (!rafId) rafId = requestAnimationFrame(tick);

      if (!visible) {
        ring.classList.remove('is-hidden');
        dot.classList.remove('is-hidden');
        visible = true;
      }

      ring.classList.toggle('is-hovering', !!(e.target && e.target.closest(INTERACTIVE)));
    });

    document.addEventListener('mouseleave', function () {
      ring.classList.add('is-hidden');
      dot.classList.add('is-hidden');
      visible = false;
    });

    document.addEventListener('mouseenter', function () {
      ring.classList.remove('is-hidden');
      dot.classList.remove('is-hidden');
      visible = true;
    });

    document.addEventListener('mousedown', function () {
      ring.classList.add('is-clicking');
      dot.classList.add('is-clicking');
    });
    document.addEventListener('mouseup', function () {
      ring.classList.remove('is-clicking');
      dot.classList.remove('is-clicking');
    });
  }


  /* ═══════════════════════════════════════════════════════════
     6. CHAR REVEAL — Statement Wall Buchstaben-für-Buchstaben
     Splitet [data-char-reveal] Elemente in .ev-char-span Spans.
     IntersectionObserver triggert .is-visible mit gestaffeltem Delay.
  ═══════════════════════════════════════════════════════════ */

  function initCharReveal() {
    var SELECTOR = '[data-char-reveal]';
    var CHAR_DELAY = 0.032; /* Sekunden zwischen Zeichen */
    var CHAR_DELAY_MOBILE = 0.022;
    var isMobile = window.innerWidth < 750;
    var delay = isMobile ? CHAR_DELAY_MOBILE : CHAR_DELAY;

    function splitChars(el) {
      if (el.querySelector('.ev-char-span')) return; /* Guard: bereits gesplitet */

      var raw = el.textContent.trim();
      var offset = 0; /* globaler Delay-Offset für mehrzeilige Elemente */

      /* Prüfe ob Geschwister auch char-reveal haben — dann Offset weiterführen */
      var siblings = el.parentElement
        ? Array.prototype.slice.call(el.parentElement.querySelectorAll('[data-char-reveal]'))
        : [];
      var myIndex = siblings.indexOf(el);
      for (var s = 0; s < myIndex; s++) {
        offset += siblings[s].textContent.trim().replace(/\s+/g, '').length * delay + 0.1;
      }

      var html = '';
      var charCount = 0;
      for (var i = 0; i < raw.length; i++) {
        var ch = raw[i];
        if (ch === ' ') {
          html += '<span class="ev-char-span ev-char-span--space" aria-hidden="true"> </span>';
        } else {
          var d = (offset + charCount * delay).toFixed(3);
          html += '<span class="ev-char-span" style="--char-delay:' + d + 's" aria-hidden="true">' + ch + '</span>';
          charCount++;
        }
      }

      el.innerHTML = html;
      el.setAttribute('aria-label', raw); /* Screenreader liest Original */
    }

    function revealEl(el) {
      el.querySelectorAll('.ev-char-span:not(.ev-char-span--space)').forEach(function (span) {
        span.classList.add('is-visible');
      });
    }

    function observe() {
      var els = document.querySelectorAll(SELECTOR);
      if (!els.length) return;

      if (reducedMotion) {
        els.forEach(function (el) { el.style.opacity = '1'; });
        return;
      }

      els.forEach(splitChars);

      if (!('IntersectionObserver' in window)) {
        els.forEach(revealEl);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealEl(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -60px 0px', threshold: 0.15 }
      );

      els.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }
  }


  /* ═══════════════════════════════════════════════════════════
     7. COLLECTION PAGE — body.ev-is-collection + Stagger-Upgrade
     Setzt Klasse für CSS-Collection-Header-Targeting.
     Gibt Produktkarten auf Kollektionsseiten stärkere
     Page-Load-Delays (sichtbare Karten staggern beim Laden).
  ═══════════════════════════════════════════════════════════ */

  function initCollectionPage() {
    /* Nur auf Kollektionsseiten aktiv */
    var isCollection = window.location.pathname.indexOf('/collections/') !== -1
      && window.location.pathname.indexOf('/products/') === -1;
    if (!isCollection) return;

    document.body.classList.add('ev-is-collection');

    if (reducedMotion) return;

    /* Warte auf DOMContentLoaded, dann setze stärkere Stagger-Delays
       auf die ersten 12 Produktkarten, die beim Laden direkt sichtbar sind */
    function applyCollectionStagger() {
      var cards = document.querySelectorAll('.product-grid__card, .product-grid__item');
      var vh = window.innerHeight;

      cards.forEach(function (card, i) {
        /* Nur Karten die beim Laden oberhalb des Folds liegen */
        var rect = card.getBoundingClientRect();
        if (rect.top < vh && i < 12) {
          var baseDelay = (i * 0.075).toFixed(3);
          card.style.setProperty('--animate-delay', baseDelay + 's');
          card.setAttribute('data-animate-dir', 'product');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyCollectionStagger);
    } else {
      applyCollectionStagger();
    }
  }


  /* ═══════════════════════════════════════════════════════════
     8. DIVINE PARTICLES — Generative Lichtpartikel im Vers-Moment
     Canvas-basiert, schwebende Goldpartikel steigen auf.
     „EVRLIGHT" = Ever Light — das ist das visuelle Manifest.
     Performance: IntersectionObserver pausiert rAF wenn off-screen.
     prefers-reduced-motion: kein Canvas wird eingefügt.
  ═══════════════════════════════════════════════════════════ */

  function initDivineParticles() {
    if (reducedMotion) return;

    var container = document.getElementById('verse-of-day');
    if (!container) return;

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = [
      'position:absolute',
      'inset:0',
      'width:100%',
      'height:100%',
      'pointer-events:none',
      'z-index:0',
      'display:block',
    ].join(';');

    /* Canvas vor allen anderen Kindern einfügen */
    container.insertBefore(canvas, container.firstChild);

    var ctx = canvas.getContext('2d');
    var particles = [];
    var PARTICLE_COUNT = 28; /* reduziert von 48 — ausreichend für den Effekt */
    var rafId = null;
    var isVisible = false;

    /* Partikel-Fabrik */
    function createParticle(randomY) {
      var size = 0.7 + Math.random() * 1.6;
      return {
        x:        Math.random() * (canvas.width || 400),
        y:        randomY !== undefined ? randomY : (canvas.height || 400) * (0.2 + Math.random() * 0.8),
        vx:       (Math.random() - 0.5) * 0.25,
        vy:       -(0.18 + Math.random() * 0.42),  /* aufwärts */
        size:     size,
        maxAlpha: 0.12 + Math.random() * 0.38,
        /* Jedes Partikel hat eine eigene Atemphase */
        phase:    Math.random() * Math.PI * 2,
        speed:    0.007 + Math.random() * 0.011,
        waveAmp:  0.1 + Math.random() * 0.2,       /* horizontales Wabern */
      };
    }

    function initParticles() {
      canvas.width  = container.offsetWidth;
      canvas.height = container.offsetHeight;
      particles = [];
      for (var i = 0; i < PARTICLE_COUNT; i++) {
        /* Initiale y-Position über die gesamte Höhe verteilt */
        var y = Math.random() * canvas.height;
        particles.push(createParticle(y));
      }
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      var w = canvas.width;
      var h = canvas.height;

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];

        p.phase += p.speed;
        var alpha = Math.max(0, Math.sin(p.phase) * p.maxAlpha);

        p.x += p.vx + Math.sin(p.phase * 0.6) * p.waveAmp;
        p.y += p.vy;

        if (p.y < -6) {
          particles[i] = createParticle(h + 4);
          continue;
        }
        if (p.x < -6)    p.x = w + 4;
        if (p.x > w + 6) p.x = -4;

        if (alpha < 0.005) continue;

        /* shadowBlur statt createRadialGradient — kein GC-Druck, gleicher Glow-Effekt */
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.shadowBlur = p.size * 10;
        ctx.shadowColor = 'rgb(201,166,128)';
        ctx.fillStyle = 'rgb(212,184,150)';
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }

      if (isVisible) {
        rafId = requestAnimationFrame(draw);
      } else {
        rafId = null;
      }
    }

    /* IntersectionObserver: nur animieren wenn sichtbar */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        isVisible = entries[0].isIntersecting;
        if (isVisible && !rafId) {
          rafId = requestAnimationFrame(draw);
        }
      }, { threshold: 0.05 });
      io.observe(container);
    } else {
      /* Kein IO-Support → immer animieren */
      isVisible = true;
    }

    initParticles();

    /* ResizeObserver statt window.resize → kein offsetWidth-Read im draw()-Loop */
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { initParticles(); }).observe(container);
    } else {
      window.addEventListener('resize', initParticles, { passive: true });
    }
  }


  /* ═══════════════════════════════════════════════════════════
     7. PARALLAX — media-with-content Bild scrollt langsamer
     Nur Desktop (> 749px), nur transform (GPU-composited).
     rAF mit ticking-Flag — kein doppeltes Frame-Request.
  ═══════════════════════════════════════════════════════════ */

  function initParallax() {
    if (reducedMotion) return;
    if (window.innerWidth < 750) return;

    var SELECTOR = '.media-with-content__media';
    var STRENGTH = 0.35;
    /* Cache: { el, centerPageY, halfH } — wird bei collect() berechnet, nicht pro Frame */
    var items = [];
    var ticking = false;

    function collect() {
      /* Lese Layout einmalig — kein getBoundingClientRect im Scroll-Handler */
      items = Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).map(function (el) {
        var rect = el.getBoundingClientRect();
        var pageY = rect.top + window.scrollY; /* absolute Y-Position auf der Seite */
        return { el: el, centerPageY: pageY + rect.height * 0.5, halfH: rect.height * 0.5 };
      });
    }

    function update() {
      var scrollY = window.scrollY;
      var vh = window.innerHeight;

      items.forEach(function (item) {
        /* Viewport-Zentrum relativ zum Element berechnen — reine Arithmetik, kein Layout-Read */
        var viewCenterY = scrollY + vh * 0.5;
        var progress = (viewCenterY - item.centerPageY) / vh;

        /* Sichtbarkeits-Check ohne getBoundingClientRect */
        var topOnScreen = item.centerPageY - item.halfH - scrollY;
        if (topOnScreen > vh * 1.5 || topOnScreen < -vh * 1.5) return;

        var offset = (progress * vh * STRENGTH).toFixed(2);
        item.el.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    collect();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });

    /* will-change nur während Scroll-Interaktion, danach freigeben */
    var scrollEndTimer = null;
    window.addEventListener('scroll', function () {
      items.forEach(function (item) { item.el.style.willChange = 'transform'; });
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(function () {
        items.forEach(function (item) { item.el.style.willChange = 'auto'; });
      }, 200);
    }, { passive: true });

    /* Bei Resize Positionen neu berechnen */
    window.addEventListener('resize', function () {
      collect();
      update();
    }, { passive: true });

    document.addEventListener('shopify:section:load', function () {
      collect();
      update();
    });
  }


  /* ═══════════════════════════════════════════════════════════
     7. MARQUEE SKEW — Scroll-Velocity-Tilt auf dem Marquee
     Nur Desktop mit feinem Pointer.
     Lerp auf currentSkew → weiche Rückkehr zu 0.
  ═══════════════════════════════════════════════════════════ */

  function initMarqueeSkew() {
    if (reducedMotion) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;

    var SELECTOR = '.marquee, marquee-component';
    var MAX_SKEW = 2.5;   /* Grad */
    var VELOCITY_FACTOR = 0.018;
    var LERP_FACTOR = 0.12;

    var els = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!els.length) return;

    var lastScrollY = window.scrollY;
    var currentSkew = 0;
    var targetSkew = 0;
    var rafId = null;

    function tick() {
      currentSkew += (targetSkew - currentSkew) * LERP_FACTOR;
      var skewStr = 'skewX(' + currentSkew.toFixed(3) + 'deg)';
      els.forEach(function (el) {
        el.style.transform = skewStr;
      });

      /* Weiterlaufen bis fast null */
      if (Math.abs(currentSkew) > 0.01 || Math.abs(targetSkew) > 0.01) {
        rafId = requestAnimationFrame(tick);
      } else {
        els.forEach(function (el) { el.style.transform = ''; });
        rafId = null;
      }
    }

    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      var velocity = scrollY - lastScrollY;
      lastScrollY = scrollY;

      targetSkew = Math.max(-MAX_SKEW, Math.min(MAX_SKEW, velocity * VELOCITY_FACTOR));

      if (!rafId) rafId = requestAnimationFrame(tick);
    }, { passive: true });
  }


  /* ═══════════════════════════════════════════════════════════
     BOOTSTRAP — run everything
  ═══════════════════════════════════════════════════════════ */

  function boot() {
    initScrollFade();
    initMagneticButtons();
    initTextReveal();
    initVerseOfDay();
    initCharReveal();
    initCollectionPage();
    initDivineParticles();
    initParallax();
    initMarqueeSkew();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Cursor nach allen anderen Overlays ins DOM einfügen,
     damit es im Paint-Order garantiert ganz oben liegt. */
  window.addEventListener('load', initCustomCursor);

})();
